export default () => ({
  list: [],
  tree: []
})
